import React from 'react';
import { Chip } from '@mui/material';
import EmptyCircle from '../../../assets/empty-circle.svg';
import SelectedCircle from '../../../assets/selected-circle.svg';
import { palette, spaces } from '../../../assets/styles/themes/tokens';

interface FilterChipProps {
  value: string;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({ value, label, onClick, isSelected }) => {
  const handleClick = () => onClick();
  const icon = isSelected ? 
    <SelectedCircle data-testid='selected-circle' /> :
    <EmptyCircle data-testid='empty-circle' />;

  return (  
    <Chip 
      key={value}
      label={label}
      onClick={handleClick}
      icon={icon}
      clickable
      sx={{
        border: `1px solid ${isSelected ? palette.primary.main : palette.components.chip.defaultEnabled}`,
        padding: parseInt(spaces.xxs) - 1 + 'px',
        background: 'transparent',
        '&:hover': {
          background: 'transparent',
        },
        '& .MuiChip-label': {
          paddingX: spaces.xs,
          paddingY: spaces.xxxs,
        },
        '& .MuiChip-icon': {
          marginX: 0,
        },
      }}
    />
  );
};

export default FilterChip;
